import { render, staticRenderFns } from "./ClaioImageSizeSelector.vue?vue&type=template&id=6477fcf0&"
import script from "./ClaioImageSizeSelector.vue?vue&type=script&lang=ts&"
export * from "./ClaioImageSizeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports